import { useMemo } from 'react';
import { useProductContext } from '~/components/organisms/products/productSingleResult/productResultContext';
import styles from './productColors.module.scss';

const ProductColors = () => {
    const { result } = useProductContext();

    const sizes = useMemo(() => {
        const data = result['params.velikosti-1'] ?? [];
        if (typeof data === 'string') {
            return data.split(',').map((size) => size.trim());
        }
        return [...data];
    }, [result]);

    if (!sizes) {
        return;
    }

    return (
        <div className={styles.colors}>
            <ul>
                {typeof sizes === 'string' ? (
                    <li>
                        <span className={styles.color}>{sizes}</span>
                    </li>
                ) : (
                    sizes.map((size, index) => (
                        <li key={index}>
                            <span className={styles.color}>{size}</span>
                        </li>
                    ))
                )}
            </ul>
        </div>
    );
};

export default ProductColors;
